"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("./config"));
var core_1 = require("@eres/core");
function searchQA(request) {
    return rest_1.httpPost(config_1.default.askMalikAPI().endPoint() + "faq/search", request);
}
exports.searchQA = searchQA;
function submitQAFeedback(request) {
    return rest_1.httpPost(config_1.default.askMalikAPI().endPoint() + "telemetry/userfeedback", request);
}
exports.submitQAFeedback = submitQAFeedback;
function postQuestion(request, headers) {
    var formData = new FormData();
    var question = { "question": request.question, "src": request.src };
    formData.append("jsonDocument", JSON.stringify(question));
    formData.append("requester.name", request.name);
    formData.append("requester.email", request.email);
    formData.append("requester.mobile", request.mobile);
    return rest_1.httpPostRaw(config_1.default.dldCmsAPI().endPoint() + "forms/public-query/submit", formData, headers)
        .then(validateResponse);
}
exports.postQuestion = postQuestion;
function getPostQuestionUrl() {
    return config_1.default.dldCmsAPI().endPoint() + "forms/public-query/submit";
}
exports.getPostQuestionUrl = getPostQuestionUrl;
function getAudioUrl(qa) {
    var id = qa.audioHash;
    if (!core_1.StringUtil.isEmptyStringOrNull(id)) {
        return config_1.default.askMalikAPI().endPoint() + "faq/audios/" + id + ".mp3";
    }
    return undefined;
}
exports.getAudioUrl = getAudioUrl;
function validateResponse(response) {
    if (response == undefined) {
        return Promise.reject("Empty response");
    }
    else if (response.validationErrorsList && response.validationErrorsList.length > 0) {
        var reason = getValidationError(response.validationErrorsList);
        return Promise.reject(reason);
    }
    return Promise.resolve(response.response);
}
function getValidationError(errors) {
    var errorMsg = errors.map(function (error) {
        return error.errorMessage;
    });
    return errorMsg.join("\n");
}
exports.getValidationError = getValidationError;
